import React from 'react';
import Modal from '../common/Modal';
import Row from '../common/Row';
import Icon from '../common/Icon';
import dayjs from 'dayjs';
import { downloadICSFile } from './constants/handleCalendarEvents';
import { downloadBlob } from '../../helpers/downloadBlob';

var utc = require('dayjs/plugin/utc');
var tz = require('dayjs/plugin/timezone');
dayjs.extend(utc);
dayjs.extend(tz);
// Convert UTC times from database to the specified zone,
// so the datetime input appears independent from the zone.
const toLocalTime = (time, zone) => {
  return dayjs.utc(time).tz(zone).format('MM/DD/YYYY h:mm A');
};

const CalendarEventViewer = ({
  displayValue,
  calendarEvent,
  viewEvent,
  setViewEvent,
}) => {
  const handleClick = (e) => {
    setViewEvent(false);
  };
  const handleDownloadEvent = async () => {
    const ics = await downloadICSFile(calendarEvent.id);
    if (ics.ok) {
      let filename = `${calendarEvent.summary}.ics`;
      downloadBlob(new Blob([ics.data]), filename);
    }
  };

  return (
    <Modal title='metadata-viewer' show={viewEvent} onClose={handleClick}>
      <header>
        <h3>ICS Calendar Event</h3>
      </header>
      <div className='details' style={{ border: 'none' }}>
        <h4 style={{ margin: '6px 12px' }}>
          {displayValue}
          <Icon
            icon='download'
            title='Download'
            className='right'
            onClick={handleDownloadEvent}
          />
        </h4>
        <hr />
        <Row name='Summary:' value={calendarEvent.summary} />
        <Row name='Description:' value={calendarEvent.description} />
        <Row
          name='Location:'
          value={calendarEvent.location || <i>Not provided</i>}
        />
        <Row name='Start Time:'>
          {toLocalTime(calendarEvent.dtstart, calendarEvent.timezone)}
        </Row>
        <Row
          name='End Time:'
          value={toLocalTime(calendarEvent.dtend, calendarEvent.timezone)}
        />
        <Row name='Timezone:' value={calendarEvent.timezone} />
        <Row
          name='Alert:'
          value={calendarEvent.alert_trigger || <i>Not provided</i>}
        />
        <Row name='Status:' value={calendarEvent.status} />
        <Row name='UID:' value={calendarEvent.uid} />
      </div>
    </Modal>
  );
};

export default CalendarEventViewer;
